<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.43262 3.15039C9.09296 3.15051 10.4395 4.49686 10.4395 6.15723V17.8428C10.4395 19.5031 9.09296 20.8495 7.43262 20.8496C5.77218 20.8496 4.42578 19.5032 4.42578 17.8428V6.15723C4.42578 4.49678 5.77218 3.15039 7.43262 3.15039ZM7.43262 4.84961C6.71106 4.84961 6.125 5.43567 6.125 6.15723V17.8428C6.125 18.5643 6.71106 19.1504 7.43262 19.1504C8.15407 19.1503 8.73926 18.5643 8.73926 17.8428V6.15723C8.73926 5.43574 8.15407 4.84973 7.43262 4.84961Z"
      fill="#FAFAFA" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.5674 3.15039C18.2277 3.15051 19.5742 4.49686 19.5742 6.15723V17.8428C19.5742 19.5031 18.2277 20.8495 16.5674 20.8496C14.9069 20.8496 13.5605 19.5032 13.5605 17.8428V6.15723C13.5605 4.49678 14.9069 3.15039 16.5674 3.15039ZM16.5674 4.84961C15.8458 4.84961 15.2598 5.43567 15.2598 6.15723V17.8428C15.2598 18.5643 15.8458 19.1504 16.5674 19.1504C17.2888 19.1503 17.874 18.5643 17.874 17.8428V6.15723C17.874 5.43574 17.2888 4.84973 16.5674 4.84961Z"
      fill="#FAFAFA" />
  </svg>
</template>
